export default __webpack_public_path__ + "static/media/Marianne-Regular.a0d9b746.woff";